import { useEffect, useState } from "react";
import { ErrorMessage, Field, useFormikContext } from "formik";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePickerWithIcon from "../../pages/DatePickerWithIcon";
import _ from "lodash";
import { t } from "i18next";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TextField } from "@mui/material";
import Select from "react-select";

const KickoffSessionCardForm = (props) => {

  const {
    isTimezoneListLoading, timezoneList,
    isLanguageListLoading, languageList
  } = props;

  const {
    setFieldValue, setFieldTouched, setFieldError,
    values,
    handleChange, handleBlur, errors, touched
  } = useFormikContext();

  const [kickoffTimeValidation, setKickoffTimeValidation] = useState(false);

  useEffect(() => {
    console.log("values", values)
    if ((values.kickOffSession.sessionStartDate &&
      !values.kickOffSession.sessionEndDate) ||
      (values.kickOffSession.sessionStartDate != values.kickOffSession.sessionEndDate)
    ) {
      setFieldValue("kickOffSession.sessionEndDate", values.kickOffSession.sessionStartDate)
    }

    if (values.kickOffSession.sessionStartDate && values.kickOffSession.sessionStartTime) {
      const sessionArray = values.sessionArray;
      const kickOffStartDate = values.kickOffSession.sessionStartDate;
      const kickOffStartTime = values.kickOffSession.sessionStartTime;
      if (!_.isEmpty(sessionArray)) {
        
        const sortedSessionArray = _.sortBy(sessionArray, 'sessionStartDateTime').reverse()
        const sessionStartDate = moment(sortedSessionArray[0].sessionStartDateTime, 'YYYY-MM-DD HH:mm');
        const kickoffStartDateM = moment(kickOffStartDate).format('DD/MM/YYYY');
        // const kickoffEndDateM = moment(kickoffEndDate).format('DD/MM/YYYY');
        const kickoffStartDateTime = moment(`${kickoffStartDateM} ${kickOffStartTime}`, 'DD/MM/YYYY HH:mm');
        // const kickoffEndDateTime = moment(`${kickoffEndDateM} ${kickoffEndTime}`, 'DD/MM/YYYY HH:mm');
        console.log("values12", kickoffStartDateTime.format('DD/MM/YYYY HH:mm'), sessionStartDate.format('DD/MM/YYYY HH:mm'))
        if (kickoffStartDateTime.isAfter(sessionStartDate)) {
          setKickoffTimeValidation(true);
        } else {
          setKickoffTimeValidation(false);
        }
      } else {
        setKickoffTimeValidation(false);
      }
    }
  }, [values])

  return (
    <>
      <div className="card formcardd">
        <h5 className="card-title mb-3">
          {t("kickOffSession")}
        </h5>
        <div className="row g-3">
          {/* Timezone */}
          <div className="col-md-6">
            <label
              htmlFor={`kickOffSession.sessionTimezone`}
              className="form-label"
            >
              {t("timezone")}
              <sup className="text-danger">*</sup>
            </label>
            <Select
              isMulti={false}
              name={`kickOffSession.sessionTimezone`}
              className={`basic-multi-select w-100 multi-label-select form-control 
                ${errors?.kickOffSession?.sessionTimezone &&
                  touched?.kickOffSession?.sessionTimezone
                  ? "is-invalid"
                  : ""
                }
              `}
              classNamePrefix="xsel"
              options={timezoneList}
              isLoading={isTimezoneListLoading}
              value={timezoneList.filter(tz => tz.value == values.kickOffSession.sessionTimezone)}
              onMenuOpen={(e) => { setFieldTouched(`kickOffSession.sessionTimezone`, true) }}
              onChange={(e) => {
                setFieldValue(`kickOffSession.sessionTimezone`, e.value)
                setFieldTouched(`kickOffSession.sessionTimezone`, true)
              }}
            />
            <ErrorMessage
              name={`kickOffSession.sessionTimezone`}
              component="div"
              className="invalid-feedback"
            />
          </div>

          {/* Language */}
          <div className="col-md-6">
            <label
              htmlFor={`kickOffSession.sessionLanguage`}
              className="form-label"
            >
              {t("language")}
              <sup className="text-danger">*</sup>
            </label>
            <Select
              isMulti={false}
              name={`kickOffSession.sessionLanguage`}
              className={`basic-multi-select w-100 multi-label-select form-control 
                ${errors?.kickOffSession?.sessionLanguage &&
                  touched?.kickOffSession?.sessionLanguage
                  ? "is-invalid"
                  : ""
                }
              `}
              classNamePrefix="xsel"
              options={languageList}
              isLoading={isLanguageListLoading}
              onMenuOpen={(e) => { setFieldTouched(`kickOffSession.sessionLanguage`, true) }}
              value={languageList.filter(lang => lang.value == values.kickOffSession.sessionLanguage)}
              onChange={(e) => {
                setFieldValue(`kickOffSession.sessionLanguage`, e.value)
                setFieldTouched(`kickOffSession.sessionLanguage`, true)
              }}
            // isDisabled={!isEdit}
            />
            <ErrorMessage
              name={`kickOffSession.sessionLanguage`}
              component="div"
              className="invalid-feedback"
            />
          </div>

          {/* Start Date */}
          <div className="col-md-6">
            <label
              htmlFor="kickOffSession.sessionStartDate"
              className="form-label"
            >
              {t("startDate")}
              <sup className="text-danger">*</sup>
            </label>
            <Field
              name="kickOffSession.sessionStartDate"
              component={DatePickerWithIcon}
              className={`form-control 
                ${errors?.kickOffSession?.sessionStartDate &&
                  touched?.kickOffSession?.sessionStartDate
                  ? "is-invalid"
                  : ""
                }
              `}
              placeholder="DD-MM-YYYY"
              isKickoffStartDate={true}
              value={values.kickOffSession?.sessionStartDate ? moment(values.kickOffSession?.sessionStartDate).format('DD-MM-YYYY') : ""}
            />
            <ErrorMessage
              name="kickOffSession.sessionStartDate"
              component="div"
              className="invalid-feedback"
            />
          </div>

          {/* Kick off End Date */}
          <div className="col-md-6">
            <label
              htmlFor="kickoffEndDate"
              className="form-label"
            >
              {t("endDate")}
              <sup className="text-danger">*</sup>
            </label>
            <Field
              name="kickOffSession.sessionEndDate"
              component={DatePickerWithIcon}
              className={`form-control 
                ${errors?.kickOffSession?.sessionEndDate &&
                  touched?.kickOffSession?.sessionEndDate
                  ? "is-invalid"
                  : ""
                }
              `}
              placeholder="DD-MM-YYYY"
              disabled={true}
              isKickoffEndDate={true}
              value={values.kickOffSession?.sessionEndDate ? moment(values.kickOffSession?.sessionEndDate).format('DD-MM-YYYY') : ""}
            />
            <ErrorMessage
              name="kickOffSession.sessionEndDate"
              component="div"
              className="invalid-feedback"
            />
          </div>

          {/* Kickoff Start Time */}
          <div className="col-md-6">
            <label
              htmlFor="kickOffSession.sessionStartTime"
              className="form-label"
            >
              {t("startTime")}
              <sup className="text-danger">*</sup>
            </label>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                name="kickOffSession.sessionStartTime"
                className={`form-control ${errors?.kickOffSession?.sessionStartTime &&
                  touched?.kickOffSession?.sessionStartTime
                  ? "is-invalid"
                  : ""
                  }`}
                placeholder="hh:mm A"
                value={values.kickOffSession.sessionStartTime ?
                  moment(values.kickOffSession.sessionStartTime, 'HH:mm') : null}
                onChange={(timeValue) => {
                  setFieldTouched('kickOffSession.sessionStartTime', true)
                  if (timeValue) {
                    timeValue = moment(timeValue).format('HH:mm');
                    setFieldValue(`kickOffSession.sessionStartTime`, timeValue);
                  } else {
                    setFieldValue(`kickOffSession.sessionStartTime`, "");
                  }
                }}
                minutesStep={1}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <ErrorMessage
              name="kickOffSession.sessionStartTime"
              component="div"
              className="invalid-feedback"
            />
            {kickoffTimeValidation ? (
              <span className="trainer_val text-danger">
                {t("kickoffSessionCanNotBeAfterTheSessionDate")}
              </span>
            ) : (
              ""
            )}
          </div>

          {/* Kick off End Time */}
          <div className="col-md-6">
            <label
              htmlFor="kickOffSession.sessionEndTime"
              className="form-label"
            >
              {t("endTime")}
              <sup className="text-danger">*</sup>
            </label>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                name="kickOffSession.sessionEndTime"
                className={`form-control 
                  ${errors?.kickOffSession?.sessionEndTime &&
                    touched?.kickOffSession?.sessionEndTime
                    ? "is-invalid"
                    : ""
                  }
                `}
                placeholder="hh:mm A"
                value={values.kickOffSession.sessionEndTime ? moment(values.kickOffSession.sessionEndTime, 'HH:mm') : null}
                onChange={(timeValue) => {
                  setFieldTouched('kickOffSession.sessionEndTime', true)
                  if (timeValue) {
                    timeValue = moment(timeValue).format('HH:mm');
                    setFieldValue(`kickOffSession.sessionEndTime`, timeValue);
                  } else {
                    setFieldValue(`kickOffSession.sessionEndTime`, "");
                  }
                }}
                minutesStep={1}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <ErrorMessage
              name="kickOffSession.sessionEndTime"
              component="div"
              className="invalid-feedback"
            />
          </div>

          {/* Mode of Attandance */}      
      <div className="col-md-12">
            <label
              id="kickOffSession.modeOfAttendance"
              htmlFor="kickOffSession.modeOfAttendance"
              className="form-label"
            >
              {t("modeOfAttendance")}<sup className="text-danger">*</sup>
            </label>
            <div className="d-flex gap-3">
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  className="form-check-input wb"
                  type="radio"
                  name="kickOffSession.modeOfAttendance"
                  id="kickOffSession.modeOfAttendanceOnline"
                  value="online" // Automatically updates the Formik state
                />
                <label
                  className="form-check-label"
                  htmlFor="kickOffSession.modeOfAttendanceOnline"
                >
                 {t("online")}
                </label>
              </div>
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  className="form-check-input wb"
                  type="radio"
                  name="kickOffSession.modeOfAttendance"
                  id="kickOffSession.modeOfAttendanceOnsite"
                  value="onsite" // Automatically updates the Formik state
                />
                <label
                  className="form-check-label"
                  htmlFor="kickOffSession.modeOfAttendanceOnsite"
                >
                  {t("onsite")}
                </label>
              </div>
            </div>
          </div>

        
          {/* Kick off URL */}
          {values?.kickOffSession?.modeOfAttendance === "online" && 
          <div className="col-md-12">
          <label
            htmlFor="kickOffSession.sessionURL"
            className="form-label"
          >
            {t("URL")}
            <sup className="text-danger">*</sup>
          </label>
          <Field
            name="kickOffSession.sessionURL"
            type="text"
            className={`form-control 
              ${errors?.kickOffSession?.sessionURL &&
                touched?.kickOffSession?.sessionURL
                ? "is-invalid"
                : ""
              }
            `}
            placeholder={t("enterURL")}
          />
          <ErrorMessage
            name="kickOffSession.sessionURL"
            component="div"
            className="invalid-feedback"
          />
        </div>
        }
          

          {/* Address */}
          {values?.kickOffSession?.modeOfAttendance === "onsite" && 
          <div className="col-md-12">
            <label
              htmlFor="kickOffSession.sessionAddress"
              className="form-label"
            >
              {t("address")}
              <sup className="text-danger">*</sup>{" "}
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-disabled">
                    {t("InfoTextWillComehere")}
                  </Tooltip>
                }
              >
                <span className="d-inline-block">
                  <span className="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path
                        d="M8 0C3.83984 0 0.5 3.36914 0.5 7.5C0.5 11.6602 3.83984 15 8 15C12.1309 15 15.5 11.6602 15.5 7.5C15.5 3.36914 12.1309 0 8 0ZM8 13.5938C4.63086 13.5938 1.90625 10.8691 1.90625 7.5C1.90625 4.16016 4.63086 1.40625 8 1.40625C11.3398 1.40625 14.0938 4.16016 14.0938 7.5C14.0938 10.8691 11.3398 13.5938 8 13.5938ZM9.17188 9.8438H8.70312V7.26562C8.70312 6.88477 8.38086 6.5625 8 6.5625H7.0625C6.65234 6.5625 6.35938 6.88477 6.35938 7.26562C6.35938 7.67578 6.65234 7.96875 7.0625 7.96875H7.29688V9.8438H6.82812C6.41797 9.8438 6.125 10.166 6.125 10.5469C6.125 10.957 6.41797 11.25 6.82812 11.25H9.17188C9.55273 11.25 9.875 10.957 9.875 10.5469C9.875 10.166 9.55273 9.8438 9.17188 9.8438ZM8 5.625C8.49805 5.625 8.9375 5.21484 8.9375 4.6875C8.9375 4.18945 8.49805 3.75 8 3.75C7.47266 3.75 7.0625 4.18945 7.0625 4.6875C7.0625 5.21484 7.47266 5.625 8 5.625Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </span>
                </span>
              </OverlayTrigger>
            </label>
            <Field
              as="textarea"
              name="kickOffSession.sessionAddress"
              placeholder={t("enterAddress")}
              className={`form-control 
                ${errors?.kickOffSession?.sessionAddress &&
                  touched?.kickOffSession?.sessionAddress
                  ? "is-invalid"
                  : ""
                }
              `}
              onChange={handleChange}              
              onBlur={handleBlur}              
            />
            <ErrorMessage
              name="kickOffSession.sessionAddress"
              component="div"
              className="invalid-feedback"
            />
          </div>
          }
        </div>
      </div>
    </>
  )
}

export default KickoffSessionCardForm;